import type { InternalDatapointOptions } from 'owa-analytics-types';

export function addStackTraceToEvent(analyticsOptions: InternalDatapointOptions): void {
    if (!analyticsOptions.originalStackTrace) {
        const error = new Error('EventStackTrace');
        analyticsOptions.originalStackTrace = error.stack;
    }
}
